class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.filterData = [];
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 50);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    facetForm.addEventListener('change', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.closest('.facets-wrapper') || this.closest('menu-drawer');
    if (facetWrapper) this.facetsWrapper = facetWrapper;
    
    setTimeout(() => {
      FacetFiltersForm.updateFilterCountBadges();
      FacetFiltersForm.updateFooterButtons();
    }, 0);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static saveAccordionState() {
    const openAccordions = [];
    document.querySelectorAll('.mobile-facets__details[open]').forEach((details) => {
      openAccordions.push(details.id);
    });
    return openAccordions;
  }

  static restoreAccordionState(openAccordions) {
    if (!openAccordions || openAccordions.length === 0) return;
    
    openAccordions.forEach((id) => {
      const detailsElement = document.getElementById(id);
      if (detailsElement) {
        detailsElement.setAttribute('open', '');
      }
    });
  }

  static updateFilterCountBadges() {
    const forms = document.querySelectorAll('#FacetFiltersFormMobile, .mobile-facets');
    let totalCount = 0;

    forms.forEach((form) => {
      const activeCheckboxes = form.querySelectorAll('input[type="checkbox"]:checked');
      totalCount = Math.max(totalCount, activeCheckboxes.length);
    });

    const badges = document.querySelectorAll('.filter-count-badge');
    badges.forEach((badge) => {
      badge.textContent = totalCount;
      badge.classList.toggle('active', totalCount > 0);
    });
  }

  static updateFooterButtons() {
    const footers = document.querySelectorAll('.mobile-facets__footer');
    if (!footers.length) return;

    const forms = document.querySelectorAll('#FacetFiltersFormMobile, .mobile-facets');
    let hasActiveFilters = false;

    forms.forEach((form) => {
      const activeCheckboxes = form.querySelectorAll('input[type="checkbox"]:checked');
      if (activeCheckboxes.length > 0) {
        hasActiveFilters = true;
      }
    });

    footers.forEach((footer) => {
      footer.classList.toggle('active', hasActiveFilters);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch((error) => {
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const newProductGridContainer = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer');
    
    if (!newProductGridContainer) return;

    document.getElementById('ProductGridContainer').innerHTML = newProductGridContainer.innerHTML;
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
  }

  static renderProductCount(html) {
    const countElement = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    if (countElement && container) {
      container.innerHTML = countElement.innerHTML;
      container.classList.remove('loading');
    }
    
    if (countElement && containerDesktop) {
      containerDesktop.innerHTML = countElement.innerHTML;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const openAccordions = FacetFiltersForm.saveAccordionState();

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersFormMobile .mobile-facets__details, #FacetFiltersFormDesktop .facets__disclosure'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const targetSelector = `#${element.id}`;
      const targetElement = document.querySelector(targetSelector);
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    
    FacetFiltersForm.restoreAccordionState(openAccordions);
    
    FacetFiltersForm.updateFilterCountBadges();
    FacetFiltersForm.updateFooterButtons();
    
    FacetFiltersForm.reattachEventListeners();
  }
  
  static reattachEventListeners() {
  }
  
  static setupEventDelegation() {
    document.addEventListener('click', (e) => {
      if (e.target.tagName === 'INPUT' && 
          e.target.classList.contains('mobile-facets__checkbox')) {
        const input = e.target;
        const label = input.closest('.mobile-facets__label');
        
        if (label && !input.disabled) {
          requestAnimationFrame(() => {
            if (input.type === 'checkbox') {
              label.classList.toggle('active', input.checked);
            } else if (input.type === 'radio') {
              const radioName = input.name;
              document.querySelectorAll(`input[name="${radioName}"]`).forEach((radio) => {
                const radioLabel = radio.closest('.mobile-facets__label');
                if (radioLabel) {
                  radioLabel.classList.toggle('active', radio.checked);
                }
              });
            }
            FacetFiltersForm.updateFilterCountBadges();
            FacetFiltersForm.updateFooterButtons();
          });
        }
        return;
      }
      
      const mobileLabel = e.target.closest('.mobile-facets__label');
      if (mobileLabel) {
        if (e.target.tagName === 'INPUT') return;
        
        const input = mobileLabel.querySelector('input');
        if (input && !input.disabled) {
          e.preventDefault();
          
          if (input.type === 'checkbox') {
            input.checked = !input.checked;
            mobileLabel.classList.toggle('active', input.checked);
          } else if (input.type === 'radio') {
            const radioName = input.name;
            document.querySelectorAll(`input[name="${radioName}"]`).forEach((radio) => {
              const label = radio.closest('.mobile-facets__label');
              if (label) {
                label.classList.remove('active');
              }
            });
            input.checked = true;
            mobileLabel.classList.add('active');
          }
          
          FacetFiltersForm.updateFilterCountBadges();
          FacetFiltersForm.updateFooterButtons();
          
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      
      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = activeFacetsElement.innerHTML;
      }
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count'];

    mobileElementSelectors.forEach((selector) => {
      const element = html.querySelector(selector);
      if (!element) return;

      const targetElement = document.querySelector(selector);
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
      }
    });

    const sourceElement = html.getElementById('FacetsWrapperMobile');
    if (!sourceElement) return;
    
    const targetElement = document.getElementById('FacetsWrapperMobile');
    if (targetElement) {
      targetElement.innerHTML = sourceElement.innerHTML;
    }
  }

  static renderCounts(source, target) {
    const targetCounts = target.querySelectorAll('.facets__selected');
    const sourceCounts = source.querySelectorAll('.facets__selected');

    if (sourceCounts.length !== targetCounts.length) {
      return;
    }

    targetCounts.forEach((targetCount, index) => {
      const sourceCount = sourceCounts[index];
      if (sourceCount && targetCount) {
        targetCount.outerHTML = sourceCount.outerHTML;
      }
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    
    const targetInput = event.target;
    const isInputChange = targetInput.tagName === 'INPUT' && 
                         (targetInput.type === 'checkbox' || 
                          targetInput.type === 'radio' ||
                          targetInput.classList.contains('mobile-facets__checkbox'));
    
    if (isInputChange) {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form')?.id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetFiltersFormDesktop' || form.id === 'FacetSortForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => (el.style.display = 'none'));
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
FacetFiltersForm.setupEventDelegation();

(function() {
  if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_RELOAD) {
    const urlParams = new URLSearchParams(window.location.search);
    
    const filterKeys = [];
    for (const [key, value] of urlParams.entries()) {
      if (key.startsWith('filter.') || key === 'sort_by') {
        filterKeys.push(key);
      }
    }
    
    if (filterKeys.length > 0) {
      filterKeys.forEach(key => urlParams.delete(key));
      
      const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
      window.location.replace(newUrl);
    }
  }
})();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
  }

  closeFilter(event) {
    event.preventDefault();
    
    const forms = document.querySelectorAll('#FacetFiltersFormMobile, .mobile-facets');
    forms.forEach((form) => {
      const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
        const label = checkbox.closest('.mobile-facets__label');
        if (label) {
          label.classList.remove('active');
        }
      });
    });
    
    FacetFiltersForm.updateFilterCountBadges();
    FacetFiltersForm.updateFooterButtons();
    
    const filterForm = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    filterForm.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);
